import { PageType } from "shared/lib/page-type";

import type { GameType } from "scmp-app/components/games/types";

export const pathname = "/games/crossword/:date";

export const page = {
  route(query: QueryParameters<{ entityId?: string; gameType?: GameType }>) {
    const { entityId, ...restQuery } = query;

    if (entityId) {
      return {
        pathname: `/games/crossword/${entityId}`,
        query: {
          ...restQuery,
          date: entityId,
          pageType: PageType.GamesCrosswords,
        },
      };
    }

    return {
      pathname: "/games/crossword",
      query: {
        ...restQuery,
        pageType: PageType.GamesCrosswords,
      },
    };
  },
};
